import request from '../services/index';
import message from './Message';

class Base {
    protected readonly $api = request;
    protected readonly $message = message;

    protected $showMessage(message: string | Error) {
        if (typeof message === 'string') {
            this.$message.showMessage(message);
        } else {
            this.$message.showMessage(JSON.stringify(message));
        }
    }
}
export default Base;
